export const GET_URL = {
    company: { api: 'company/company/', basename: 'view_company' },
    companysecondarydetails: { api: 'company/companysecondarydetails/', basename: 'view_companysecondarydetails' },
    company_json_config: { api: 'company/company-json-config/', basename: 'view_company_json_config' },
    company_visits: { api: 'company/company-visits/', basename: 'view_company_visits' },
    visit_media: { api: 'media/', basename: 'view_visit_media' },
    urlsmenu: { api: 'company/urlsmenu/', basename: 'view_urlsmenu' },
    ticket: { api: 'helpcenter/ticket/', basename: 'view_ticket' },
    chatbot: { api: 'helpcenter/chatbot/', basename: 'chatbot' },
    user: { api: 'users/user/', basename: 'view_user' },
    dashboard: { api: 'basic/dashboard/', basename: 'view_dashboard' },
    academicyear: { api: 'basic/academicyear/', basename: 'view_academicyear' },
    edubricz_ads: { api: 'basic/edubricz-ads/', basename: 'view_edubricz_ads' },
    feature_screens: { api: 'basic/feature-screens/', basename: 'view_feature_screens' },
    services: { api: 'catalog/services/', basename: 'view_services' },
    plans: { api: 'catalog/plans/', basename: 'view_plans' },
    taxes: { api: 'catalog/taxes/', basename: 'view_taxes' },
    billing_config: { api: 'billing/billing_config/', basename: 'view_billing_config' },
    finance_dashboard: { api: 'billing/finance_dashboard/', basename: 'view_finance_dashboard' },
    service_order: { api: 'billing/service_order/', basename: 'view_service_order' },
    company_billing_config: { api: 'billing/company_billing_config/', basename: 'view_company_billing_config' },
    issued_invoices: { api: 'billing/issued_invoices/', basename: 'view_issued_invoices' },
    invoices: { api: 'billing/invoices/', basename: 'view_invoices' },
    payments: { api: 'billing/payments/', basename: 'view_payments' },
    manual_payments: { api: 'billing/manual_payments/', basename: 'view_manual_payments' },
    agreements: { api: 'agreements/agreements/', basename: 'view_agreements' },
    quotation_plans: { api: 'agreements/quotation-plans/', basename: 'view_quotation_plans' },
    quotations: { api: 'agreements/quotations/', basename: 'view_quotations' },
    expense_types: { api: 'expenses/expense-types/', basename: 'view_expense_types' },
    expense_receivers: { api: 'expenses/expense-receivers/', basename: 'view_expense_receivers' },
    expenses: { api: 'expenses/expenses/', basename: 'view_expenses' },
    groups: { api: 'users/groups/', basename: 'view_groups' },
    erpfeature: { api: 'agreements/erpfeature/', basename: 'view_erpfeature' },
    digitalmarketingfeature: { api: 'agreements/digitalmarketingfeature/', basename: 'view_digitalmarketingfeature' },
    tasks: { api: 'tasks/tasks/', basename: 'view_tasks' },
    sprints: { api: 'tasks/sprints/', basename: 'view_sprints' },
    task_types: { api: 'tasks/task-types/', basename: 'view_task_types' },
    task_type_stages: { api: 'tasks/task-type-stages/', basename: 'view_task_type_stages' },
    client_track_report: { api: 'shared/clienttrackreport/', basename: 'view_client_track_report' },
    client_payment_gateway_report: { api: 'shared/clientpaymentgatewayreport/', basename: 'view_client_payment_gateway_report' },
    sprint_daily_updates: { api: 'tasks/sprint-daily-updates/', basename: 'view_sprint_daily_updates' },
    staff_leaves: { api: 'tasks/staff-leaves/', basename: 'view_staff_leaves' },
    client_groups: { api: 'company/client-groups/', basename: 'view_client_groups' },
    client_track_params: { api: 'company/client-track-params/', basename: 'view_client_track_params' },
    checklist_items: { api: 'company/checklist-templates/', basename: 'view_checklist_templates' },
    company_checklist_items: { api: 'company/company-checklists/', basename: 'view_company_checklists' },
    client_track_company_updates: { api: 'company/client-track-company-updates/', basename: 'view_client_track_company_updates' },
    orders_v2: { api: 'orders_v2/orders/', basename: 'view_orders_v2' },
}
export const POST_URL = {
    company: { api: 'company/company/', basename: 'add_company' },
    login: { api: 'users/login/', basename: 'add_login' },
    servercommand: { api: 'company/servercommand/', basename: 'add_servercommand' },
    uploads: { api: 'shared/uploads/', basename: 'add_uploads' },
    companysecondarydetails: { api: 'company/companysecondarydetails/', basename: 'add_companysecondarydetails' },
    company_json_config: { api: 'company/company-json-config/', basename: 'add_company_json_config' },
    company_visits: { api: 'company/company-visits/', basename: 'add_company_visits' },
    visit_media: { api: 'media/', basename: 'add_visit_media' },
    fcmregister: { api: 'users/fcmregister/', basename: 'add_fcmregister' },
    ticket: { api: 'helpcenter/ticket/', basename: 'add_ticket' },
    chatbot: { api: 'helpcenter/chatbot/', basename: 'chatbot' },
    academicyear: { api: 'basic/academicyear/', basename: 'add_academicyear' },
    edubricz_ads: { api: 'basic/edubricz-ads/', basename: 'add_edubricz_ads' },
    feature_screens: { api: 'basic/feature-screens/', basename: 'add_feature_screens' },
    services: { api: 'catalog/services/', basename: 'add_services' },
    plans: { api: 'catalog/plans/', basename: 'add_plans' },
    billing_config: { api: 'billing/billing_config/', basename: 'add_billing_config' },
    company_billing_config: { api: 'billing/company_billing_config/', basename: 'add_company_billing_config' },
    issued_invoices: { api: 'billing/issued_invoices/', basename: 'add_issued_invoices' },
    invoices: { api: 'billing/invoices/', basename: 'add_invoices' },
    payments: { api: 'billing/payments/', basename: 'add_payments' },
    manual_payments: { api: 'billing/manual_payments/', basename: 'add_manual_payments' },
    agreements: { api: 'agreements/agreements/', basename: 'add_agreements' },
    quotation_plans: { api: 'agreements/quotation-plans/', basename: 'add_quotation_plans' },
    quotations: { api: 'agreements/quotations/', basename: 'add_quotations' },
    user: { api: 'users/signup/', basename: 'add_user' },
    changepassword: { api: 'users/changepassword/', basename: 'change_password' },
    expense_types: { api: 'expenses/expense-types/', basename: 'add_expense_types' },
    expense_receivers: { api: 'expenses/expense-receivers/', basename: 'add_expense_receivers' },
    expenses: { api: 'expenses/expenses/', basename: 'add_expenses' },
    erpfeature: { api: 'agreements/erpfeature/', basename: 'view_erpfeature' },
    digitalmarketingfeature: { api: 'agreements/digitalmarketingfeature/', basename: 'view_digitalmarketingfeature' },
    tasks: { api: 'tasks/tasks/', basename: 'add_tasks' },
    sprints: { api: 'tasks/sprints/', basename: 'add_sprints' },
    task_types: { api: 'tasks/task-types/', basename: 'add_task_types' },
    task_type_stages: { api: 'tasks/task-type-stages/', basename: 'add_task_type_stages' },
    permissions_sync: { api: 'users/permissions-sync/', basename: 'add_permissions_sync' },
    client_track_report: { api: 'shared/clienttrackreport/', basename: 'add_client_track_report' },
    client_groups: { api: 'company/client-groups/', basename: 'add_client_groups' },
    client_track_params: { api: 'company/client-track-params/', basename: 'add_client_track_params' },
    checklist_items: { api: 'company/checklist-templates/', basename: 'add_checklist_templates' },
    company_checklist_items: { api: 'company/company-checklists/', basename: 'add_company_checklists' },
    client_track_company_updates: { api: 'company/client-track-company-updates/', basename: 'add_client_track_company_updates' },
    orders_v2: { api: 'orders_v2/orders/', basename: 'add_orders_v2' },
    staff_leaves: { api: 'tasks/staff-leaves/', basename: 'add_staff_leaves' },

}
export const PATCH_URL = {
    institute: { api: 'institutes/institute/', basename: 'view_institute' },
    issued_invoices: { api: 'billing/issued_invoices/', basename: 'change_issued_invoices' },
    invoices: { api: 'billing/invoices/', basename: 'change_invoices' },
    payments: { api: 'billing/payments/', basename: 'change_payments' },
    manual_payments: { api: 'billing/manual_payments/', basename: 'change_manual_payments' },
    agreements: { api: 'agreements/agreements/', basename: 'change_agreements' },
    tasks: { api: 'tasks/tasks/', basename: 'change_tasks' },
    sprints: { api: 'tasks/sprints/', basename: 'change_sprints' },
    task_types: { api: 'tasks/task-types/', basename: 'change_task_types' },
    task_type_stages: { api: 'tasks/task-type-stages/', basename: 'change_task_type_stages' },
    client_groups: { api: 'company/client-groups/', basename: 'change_client_groups' },
    client_track_params: { api: 'company/client-track-params/', basename: 'change_client_track_params' },
    checklist_items: { api: 'company/checklist-templates/', basename: 'change_checklist_templates' },
    company_checklist_items: { api: 'company/company-checklists/', basename: 'change_company_checklists' },
    client_track_company_updates: { api: 'company/client-track-company-updates/', basename: 'change_client_track_company_updates' },
    orders_v2: { api: 'orders_v2/orders/', basename: 'change_orders_v2' },

}
export const PUT_URL = {
    company: { api: 'company/company/', basename: 'change_company' },
    urlsmenu: { api: 'company/urlsmenu/', basename: 'change_urlsmenu' },
    companysecondarydetails: { api: 'company/companysecondarydetails/', basename: 'change_companysecondarydetails' },
    company_json_config: { api: 'company/company-json-config/', basename: 'change_company_json_config' },
    company_visits: { api: 'company/company-visits/', basename: 'change_company_visits' },
    ticket: { api: 'helpcenter/ticket/', basename: 'change_ticket' },
    academicyear: { api: 'basic/academicyear/', basename: 'change_academicyear' },
    feature_screens: { api: 'basic/feature-screens/', basename: 'change_feature_screens' },
    services: { api: 'catalog/services/', basename: 'change_services' },
    plans: { api: 'catalog/plans/', basename: 'change_plans' },
    expense_types: { api: 'expenses/expense-types/', basename: 'change_expense_types' },
    expenses: { api: 'expenses/expenses/', basename: 'change_expenses' },
    agreements: { api: 'agreements/agreements/', basename: 'change_agreements' },
    quotation_plans: { api: 'agreements/quotation-plans/', basename: 'change_quotation_plans' },
    quotations: { api: 'agreements/quotations/', basename: 'change_quotations' },
    user: { api: 'users/user/', basename: 'change_user' },
    tasks: { api: 'tasks/tasks/', basename: 'change_tasks' },
    sprints: { api: 'tasks/sprints/', basename: 'change_sprints' },
    client_groups: { api: 'company/client-groups/', basename: 'change_client_groups' },
    client_track_params: { api: 'company/client-track-params/', basename: 'change_client_track_params' },
    checklist_items: { api: 'company/checklist-templates/', basename: 'change_checklist_templates' },
    company_checklist_items: { api: 'company/company-checklists/', basename: 'change_company_checklists' },
    client_track_company_updates: { api: 'company/client-track-company-updates/', basename: 'change_client_track_company_updates' },

}
export const DEL_URL = {
    company: { api: 'company/company/', basename: 'delete_company' },
    edubricz_ads: { api: 'basic/edubricz-ads/', basename: 'delete_edubricz_ads' },
    feature_screens: { api: 'basic/feature-screens/', basename: 'delete_feature_screens' },
    company_visits: { api: 'company/company-visits/', basename: 'delete_company_visits' },
    visit_media: { api: 'media/', basename: 'delete_visit_media' },
    services: { api: 'catalog/services/', basename: 'delete_services' },
    expense_types: { api: 'expenses/expense-types/', basename: 'delete_expense_types' },
    expenses: { api: 'expenses/expenses/', basename: 'delete_expenses' },
    plans: { api: 'catalog/plans/', basename: 'delete_plans' },
    quotation_plans: { api: 'agreements/quotation-plans/', basename: 'delete_quotation_plans' },
    quotations: { api: 'agreements/quotations/', basename: 'delete_quotations' },
    tasks: { api: 'tasks/tasks/', basename: 'delete_tasks' },
    sprints: { api: 'tasks/sprints/', basename: 'delete_sprints' },
    task_types: { api: 'tasks/task-types/', basename: 'delete_task_types' },
    task_type_stages: { api: 'tasks/task-type-stages/', basename: 'delete_task_type_stages' },
    client_groups: { api: 'company/client-groups/', basename: 'delete_client_groups' },
    client_track_params: { api: 'company/client-track-params/', basename: 'delete_client_track_params' },
    checklist_items: { api: 'company/checklist-templates/', basename: 'delete_checklist_templates' },
    company_checklist_items: { api: 'company/company-checklists/', basename: 'delete_company_checklists' },
    client_track_company_updates: { api: 'company/client-track-company-updates/', basename: 'delete_client_track_company_updates' },
    orders_v2: { api: 'orders_v2/orders/', basename: 'delete_orders_v2' },
    staff_leaves: { api: 'tasks/staff-leaves/', basename: 'delete_staff_leaves' },

}

export const NOTIFICATION_POST_URL = {

}
